import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OrderProposalActions } from "../../actions/order-proposal.actions";
import { OrderProposalState } from "../../models/order-proposal/order-proposal-state";

const initialState: OrderProposalState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(OrderProposalActions.orderProposals.getApi, (state) => ({
		orderProposals: _.cloneDeep(state.orderProposals),
		loading: true
	})),
	on(OrderProposalActions.orderProposals.getSuccess, (state, action) => {
		const orderProposals = _.cloneDeep(_.get(state, "orderProposals", {}));
		_.forEach(_.keys(action.orderProposals), (key) => {
			_.set(
				orderProposals,
				key,
				_.unionBy(action.orderProposals[key], _.get(orderProposals, key, []))
			);
		});
		return { orderProposals, loading: false };
	}),
	on(OrderProposalActions.orderProposals.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	),
	on(OrderProposalActions.acceptProposal.acceptSuccess, (state, action) => {
		const orderProposals = _.cloneDeep(state.orderProposals);
		_.forEach(orderProposals, (proposals, key) => {
			const index = _.findIndex(proposals, { id: action.orderProposalId });
			if (index !== -1) {
				proposals[index] = {
					...proposals[index],
					proposalStatus: "ACCEPTED"
				};
			}
		});
		return {
			...state,
			orderProposals
		};
	})
);

export function orderProposalReducer(
	state: OrderProposalState | undefined,
	action: Action
): OrderProposalState {
	return reducer(state, action);
}
